import { Box, Divider, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, useDisclosure, DrawerFooter, Select, FormErrorMessage, Modal, ModalOverlay, ModalHeader, ModalContent, ModalCloseButton, ModalBody, VStack, HStack, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { EmployeerDetail, EmployementDetail, EmployerDetailHeaders } from "./moda";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import EmploymentDetailLogo from "../../../../../assets/images/EmploymentDetailLogo.png";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../../../../../hooks/useAuth";
import { Dropdown } from "../../../../../components/DropDown/DropDown";
import { showDate } from "../../../../../utilities/helper";
import { TimeIcon } from "@chakra-ui/icons";

type props = {
  employeeId: number | null;
  data?: EmployeerDetail;
  onComplete?: any;
};

const EditEmployement = ({ employeeId, data, onComplete }: props) => {
  const { addToast } = CustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { fetchApi } = useFetch(addToast);
  const [employeerDetail, setEmployeerDetail] = useState<EmployeerDetail | undefined>(data);
  const [PCOption, setPCOption] = useState([]);
  const [BPOption, setBPOption] = useState([]);
  const [UCOption, setUCOption] = useState([]);
  const [branchName, setBranchName] = useState<any>([]);
  const [departments, setDepartments] = useState<any>([]);
  const [designation, setDesignation] = useState<any>([]);
  const [shiftOptions, setShiftOptions] = useState<any[]>([]);
  const { isOpen: isHistoryOpen, onOpen: onHistoryOpen, onClose: onHistoryClose } = useDisclosure();
  const [historyLogs, setHistoryLogs] = useState<any[]>([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const { hasPermission } = useAuth();
  const [showEffectiveDate, setShowEffectiveDate] = useState(false);

  const salaryCompensationSchema: any = yup.object().shape({
    payroll_Company_Id: yup.number().required("Payroll Company is required").typeError("Payroll Compnay is Required"),
    us_Company_Id: yup.number().required("Company is required").typeError("Compnay is Required"),
    branch_Id: yup.number().required("Branch is required").typeError("Branch is Required"),
    department_Id: yup.number().required("Department is required").typeError("Department is Required"),
    shift: yup.number().required("Shift is required").typeError("Shift is Required"),
    date_Of_Joining: yup.string().required("Date of Joining is required"),
    business_Process_Id: yup.number().required("Business Process is required").typeError("Business Process is Required"),
    designation_Id: yup.number().required("Designation is required").typeError("Designation is required"),
    last_Increment_Date: yup.string().nullable(),
    last_Working_Date: yup.string().nullable(),
    change_Effective_Date: yup.string().when("$showEffectiveDate", {
      is: true,
      then: (s) => s.required("Please select the date this change is effective from"),
      otherwise: (s) => s.nullable(),
    }),
  });

  const { control, handleSubmit, formState: { errors }, watch, setValue, reset, } = useForm<EmployementDetail>({
    resolver: yupResolver(salaryCompensationSchema),
    context: { showEffectiveDate },
    defaultValues: {
      ...employeerDetail,
      last_Increment_Date: employeerDetail?.last_Increment_Date,
    }
  });

  const onSubmit = async (data: any) => {
    if (!data.branch_Id || data.branch_Id === 0) {
      addToast({ message: "Branch is required", status: "error" });
      return;
    }
    if (!data.designation_Id || data.designation_Id === 0) {
      addToast({ message: "Designation is required", status: "error" });
      return;
    }
    data.empId = employeeId;
    let endpoint = `Hrlense_Employee/employmentDetails/${employeeId}`;
    const response = await fetchApi(endpoint, "PUT", data, null, "Employement Details Updated");
    if (response) {
      onComplete();
      onClose();
    }
  };


  useEffect(() => {
    if (data) {
      setEmployeerDetail(data);
      reset(data); // also reset form with latest data
    }
  }, [data, reset]);


  const PayrollCompanyOption = async () => {
    const response = await fetchApi("DropDown/payrollCompany", "GET", null, "", "");
    if (response) {
      setPCOption(response);
    }
  };
  const BusinessProcessOption = async () => {
    const response = await fetchApi("DropDown/businessProcess", "GET", null, "", "");
    if (response) {
      setBPOption(response);
    }
  };
  const UsCompanyOption = async () => {
    const response = await fetchApi("DropDown/UsCompany", "GET", null, "", "");
    if (response) {
      setUCOption(response);
    }
  };

  const loadBranchOptions = async (companyId: number) => {
    const res = await fetchApi("DropDown/branches", "GET", null, `companyId=${companyId}`, "");
    if (res) setBranchName(res);
    else setBranchName([]);
  };

  const loadDepartmentOptions = async () => {
    const res = await fetchApi("DropDown/department", "GET", null, "", "");
    if (res) setDepartments(res);
  };
  const loadDesignationOptions = async (departmentId: number) => {
    const res = await fetchApi("DropDown/designation", "GET", null, `department=${departmentId}`, "");
    if (res) setDesignation(res);
    else setDesignation(["Not Found"]);
  };

  const loadShiftOptions = async () => {
    const res = await fetchApi("DropDown/shift", "GET", null, "", "");
    if (res) setShiftOptions(res);
  };



  useEffect(() => {
    const subscription = watch((value, { name }) => {
      const changed = Number(value.us_Company_Id) !== Number(data?.company_Id) || Number(value.branch_Id) !== Number(data?.branch_Id) || Number(value.payroll_Company_Id) !== Number(data?.payroll_Company_id)
      setShowEffectiveDate(changed);
      if (name === "us_Company_Id") {
        if (value.us_Company_Id) {
          loadBranchOptions(value.us_Company_Id);
        } else {
          setBranchName([]);
        }
        setValue("branch_Id", 0, {
          shouldValidate: true,
          shouldDirty: true
        });
      }
      if (name === "department_Id") {
        if (value.department_Id) {
          setDesignation([]);
          loadDesignationOptions(value.department_Id);
        } else {
          setDesignation([]);
        }
        setValue("designation_Id", 0, {
          shouldValidate: true,
          shouldDirty: true
        });
      }

    });

    return () => subscription.unsubscribe();
  }, [watch, setValue, data]);

  useEffect(() => {
    PayrollCompanyOption();
    BusinessProcessOption();
    UsCompanyOption();
    loadDepartmentOptions();
    loadShiftOptions();
    if (data?.department_Id) {
      loadDesignationOptions(data.department_Id);
    }
  }, [employeeId]);

  function handleEditClick() {
    reset({
      payroll_Company_Id: data?.payroll_Company_id,
      us_Company_Id: data?.company_Id,
      branch_Id: data?.branch_Id,
      department_Id: data?.department_Id,
      designation_Id: data?.designation_Id,
      shift: data?.shift,
      business_Process_Id: data?.business_Process_id,
      date_Of_Joining: data?.date_Of_Joining,
      last_Increment_Date: data?.last_Increment_Date,
      last_Working_Date: data?.last_Working_Date
    });

    if (data?.company_Id) {
      loadBranchOptions(data?.company_Id).then(() => { reset((prev) => ({ ...prev, branch_Id: data?.branch_Id, })); });
    }
    if (data?.department_Id) {
      loadDesignationOptions(data.department_Id).then(() => {
        reset((prev) => ({ ...prev, Id: data?.designation_Id }));
      });
    }

    onOpen();
  }


  const fetchEmploymentHistory = async () => {
    setHistoryLoading(true);
    const response = await fetchApi(`Hrlense_EmployeeStatus/employmentLogs/${employeeId}`, "GET", null, "", "");
    if (response?.data) setHistoryLogs(response.data);
    setHistoryLoading(false);
    onHistoryOpen();
  };

  const inActiveEmployee = data?.status !== 2;

  return (
    <>
      <Box pt={2} mb={6} className="main">
        <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
          <Flex align="center" gap={3}>
            <Image src={EmploymentDetailLogo} alt={"Employment Details"} />
            <Text className="font-poppins text_sm text_medium col">Employment Details</Text>
          </Flex>
          <Flex align="center" gap={2}>
            {hasPermission("Employee", "ViewEmploymentLogHistory") &&
              <Tooltip label="View Employment history" placement="top" hasArrow>
                <IconButton aria-label="Employment History" icon={<TimeIcon boxSize="18px" color="green" />} variant="none" onClick={fetchEmploymentHistory} />
              </Tooltip>}

            {hasPermission("Employee", "UpdateEmploymentDetail") && <IconButton aria-label="Edit" icon={<Image src={EditLogo} />} variant="none" onClick={() => handleEditClick()} />}
          </Flex>
        </Flex>
        <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
          {EmployerDetailHeaders.map((data, index) => (
            <Grid key={index} templateColumns="1fr 1fr" alignItems="center" mb={2}>
              <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)">
                {data?.label}
              </Text>
              <Text className="font-poppins text_sm text_medium col">{data.label === "Date of Joining" || data.label === "Last Increment Date" ? showDate(employeerDetail?.[data?.key] as any) : employeerDetail?.[data?.key]}</Text>
            </Grid>
          ))}
          {data?.status !== 2 && (
            <Grid templateColumns="1fr 1fr" alignItems="center" mb={2} >
              <Text className="font-poppins text_sm text_medium" color="rgba(102, 102, 102, 1)" > Last Working Date </Text>
              <Text className="font-poppins text_sm text_medium col">{showDate(employeerDetail?.last_Working_Date)}</Text>
            </Grid>
          )}

        </Box>
      </Box>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
        <DrawerOverlay />
        <form onSubmit={handleSubmit(onSubmit)}>
          <DrawerContent className="drawer" display="flex" flexDirection="column" height="100%">
            <DrawerCloseButton />
            <DrawerHeader>Update Employment Details</DrawerHeader>
            <DrawerBody pb="70px" flex={1} overflow="auto">
              <Box m={6}>
                <Grid templateColumns="1fr" gap={4}>
                  {/* Payroll Company */}
                  <FormControl isInvalid={!!errors.payroll_Company_Id} isRequired>
                    <FormLabel>Payroll Company</FormLabel>
                    <Controller name="payroll_Company_Id" control={control} render={({ field }) => (
                      <Select {...field} placeholder="Select Payroll Company">
                        {PCOption.map((opt: any) => (<option key={opt.id} value={opt.id}>{opt.payroll_Company_Name}</option>))}
                      </Select>
                    )}
                    />
                    <FormErrorMessage>{errors.payroll_Company_Id?.message}</FormErrorMessage>
                  </FormControl>

                  {/* Company */}
                  <FormControl isInvalid={!!errors.us_Company_Id} isRequired>
                    <FormLabel>Company</FormLabel>
                    <Controller name="us_Company_Id" control={control} render={({ field }) => (
                      <Select {...field} placeholder="Select Company">
                        {UCOption.map((opt: any) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.company_Name}
                          </option>
                        ))}
                      </Select>
                    )}
                    />
                    <FormErrorMessage>{errors.us_Company_Id?.message}</FormErrorMessage>
                  </FormControl>
                  <Dropdown isRequired name="branch_Id" label="Branch" control={control} errors={errors} options={branchName} valueKey="branch_Id" labelKey="branchName" />
                  <Dropdown isRequired name="department_Id" label="Department" control={control} errors={errors} options={departments} valueKey="id" labelKey="departmentName" />
                  <Dropdown isRequired name="designation_Id" label="Designation" control={control} errors={errors} options={designation} valueKey="id" labelKey="designation" />
                  <Dropdown isRequired name="shift" label="Shift" control={control} errors={errors} options={shiftOptions} valueKey="id" labelKey="shift" />
                  {/* Business Process */}
                  <FormControl isInvalid={!!errors.business_Process_Id} isRequired>
                    <FormLabel>Business Process</FormLabel>
                    <Controller name="business_Process_Id" control={control}
                      render={({ field }) => (
                        <Select {...field} placeholder="Select Business Process">
                          {BPOption.map((opt: any) => (
                            <option key={opt.business_Process_Id} value={opt.business_Process_Id}>
                              {opt.business_Process_Name}
                            </option>
                          ))}
                        </Select>
                      )}
                    />
                    <FormErrorMessage>{errors.business_Process_Id?.message}</FormErrorMessage>
                  </FormControl>
                  <FormControl mb={4} isInvalid={!!errors.date_Of_Joining} isRequired>
                    <FormLabel>Date of Joining</FormLabel>
                    <Controller name="date_Of_Joining" control={control} render={({ field }) => <Input type="date" {...field} />} />
                    <FormErrorMessage>{errors.date_Of_Joining?.message}</FormErrorMessage>
                  </FormControl>
                  <FormControl mb={4} isInvalid={!!errors.last_Increment_Date} >
                    <FormLabel>Last Increment Date</FormLabel>
                    <Controller name="last_Increment_Date" control={control} render={({ field }) => <Input type="date" {...field} />} />
                    <FormErrorMessage>{errors.last_Increment_Date?.message}</FormErrorMessage>
                  </FormControl>
                  {data?.status !== 2 && (
                    <FormControl mb={4} isInvalid={!!errors.last_Working_Date} >
                      <FormLabel>Last Working Date</FormLabel>
                      <Controller name="last_Working_Date" control={control} render={({ field }) => (<Input type="date" {...field} min={data?.date_Of_Joining?.split("T")[0]} max={new Date().toISOString().split("T")[0]} />)}
                      />                      <FormErrorMessage>{errors.last_Working_Date?.message}</FormErrorMessage>
                    </FormControl>
                  )}
                  {showEffectiveDate && (
                    <FormControl mb={4} isInvalid={!!errors.change_Effective_Date} isRequired>
                      <FormLabel>Change effective from</FormLabel>
                      <Controller
                        name="change_Effective_Date"
                        control={control}
                        render={({ field }) => <Input type="date" max={new Date().toISOString().split("T")[0]} {...field} />}
                      />
                      <FormErrorMessage>{errors.change_Effective_Date?.message as string}</FormErrorMessage>
                    </FormControl>
                  )}
                </Grid>
              </Box>
            </DrawerBody>
            <DrawerFooter><Button className="btn_theme" type="submit">Update Details</Button></DrawerFooter>
          </DrawerContent>
        </form>
      </Drawer>

      <Modal isOpen={isHistoryOpen} onClose={onHistoryClose} size="lg" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius={12}>
          <ModalHeader borderBottom="0.5px solid" borderColor="gray.100" pb={3}>
            <Flex align="center" gap={3}>
              <Flex w="40px" h="40px" borderRadius="full" bg="blue.50" align="center" justify="center" fontSize="13px" fontWeight="500" color="blue.500" >
                {data?.manager?.split(" ").map((w: string) => w[0]).join("").slice(0, 2).toUpperCase()
                  || historyLogs[0]?.EmployeeName?.split(" ").map((w: string) => w[0]).join("").slice(0, 2).toUpperCase()
                  || "??"
                }
              </Flex>
              <Box>
                <Text fontSize="15px" fontWeight="500">Employment History — {historyLogs[0]?.EmployeeName || "Employee"}</Text>
                <Text fontSize="12px" color="gray.400">{historyLogs.length} change{historyLogs.length !== 1 ? "s" : ""} recorded</Text>
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody px={6} py={4}>
            {historyLoading ? (
              <Text color="gray.400" textAlign="center" py={8} fontSize="14px">Loading...</Text>
            ) : historyLogs.length === 0 ? (
              <Text color="gray.400" textAlign="center" py={8} fontSize="14px">No history found.</Text>
            ) : (
              <VStack align="stretch" spacing={0} divider={<Box h="0.5px" bg="gray.100" />}>
                {historyLogs.map((log: any, i: number) => {
                  const FIELDS = [
                    { label: "Dept", old: log.old_Department, next: log.new_Department },
                    { label: "Designation", old: log.old_Designation, next: log.new_Designation },
                    { label: "Branch", old: log.old_Branch, next: log.new_Branch },
                    { label: "Company", old: log.old_Company, next: log.new_Company },
                    { label: "Payroll Co.", old: log.old_Payroll_Company, next: log.new_Payroll_Company },
                    { label: "Process", old: log.old_Business_Process, next: log.new_Business_Process },
                    { label: "Shift", old: log.old_Shift, next: log.new_Shift },
                  ].filter(f => f.old !== f.next);

                  return (
                    <Box key={log.Id} py={5} px={4} borderWidth="1px" borderRadius="xl" bg="white" boxShadow="sm" >
                      <HStack mb={4} spacing={3} align="center">
                        <Box w="10px" h="10px" borderRadius="full" bg="blue.500" />
                        <Text fontSize="16px" fontWeight="600" color="blue.700">{showDate(log.effective_Date ? log.effective_Date : log.createdAt)}</Text>
                        {log.createdByName && (<Text fontSize="13px" color="gray.500">by <b>{log.createdByName}</b></Text>)}
                      </HStack>
                      <VStack align="stretch" spacing={3}>
                        {FIELDS.length === 0 ? (
                          <Text fontSize="13px" color="gray.400" fontStyle="italic">No field changes detected</Text>
                        ) : (
                          FIELDS.map((f, j) => (
                            <HStack key={j} spacing={4} align="center" p={3} borderRadius="lg" bg="gray.50"                             >
                              <Text fontSize="12px" fontWeight="600" color="gray.600" minW="100px" >{f.label}</Text>
                              {f.old && (
                                <>
                                  <Text fontSize="14px" color="red.400" textDecoration="line-through" fontWeight="500" >{f.old}</Text>
                                  <Text fontSize="14px" color="gray.400">→</Text>
                                </>
                              )}

                              <Text fontSize="14px" fontWeight="600" color="green.600" > {f.next || "—"}</Text>
                            </HStack>
                          ))
                        )}
                      </VStack>
                    </Box>
                  );
                })}
              </VStack>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditEmployement;
